import { render, staticRenderFns } from "./SquadStatistics.vue?vue&type=template&id=5338d915&scoped=true&"
import script from "./SquadStatistics.vue?vue&type=script&lang=js&"
export * from "./SquadStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SquadStatistics.vue?vue&type=style&index=0&id=5338d915&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338d915",
  null
  
)

export default component.exports